import { html } from 'lit';

export const iconUpload = html`
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M36 13.7255V43.9902C36 46.2413 34.125 47.9922 32 47.9922C29.75 47.9922 28 46.2413 28 43.9902V13.7255L18.75 22.8549C17.25 24.4807 14.625 24.4807 13.125 22.8549C11.5 21.3542 11.5 18.7279 13.125 17.2272L29.125 1.21935C30.625 -0.406448 33.25 -0.406448 34.75 1.21935L50.75 17.2272C52.375 18.7279 52.375 21.3542 50.75 22.8549C49.25 24.4807 46.625 24.4807 45.125 22.8549L36 13.7255ZM8 43.9902H24C24 48.4924 27.5 51.9941 32 51.9941C36.375 51.9941 40 48.4924 40 43.9902H56C60.375 43.9902 64 47.617 64 51.9941V55.9961C64 60.4983 60.375 64 56 64H8C3.5 64 0 60.4983 0 55.9961V51.9941C0 47.617 3.5 43.9902 8 43.9902ZM54 56.9966C55.625 56.9966 57 55.746 57 53.9951C57 52.3693 55.625 50.9936 54 50.9936C52.25 50.9936 51 52.3693 51 53.9951C51 55.746 52.25 56.9966 54 56.9966Z"
    />
  </svg>
`;
